<template>
  <div>
    <form @submit.prevent="handleSubmit(!v$.$invalid)">
      <div class="formgrid grid">
        <div class="field col-12 md:col-4">
          <label :class="{ 'p-error': v$.form.kode.$invalid && submitted }"
            >Kode *</label
          >
          <InputText
            v-model="form.kode"
            :class="{ 'p-invalid': v$.form.kode.$invalid && submitted }"
            type="text"
            class="w-full"
            autofocus
          />
          <small
            v-if="
              (v$.form.kode.$invalid && submitted) ||
              v$.form.kode.$pending.$response
            "
            class="p-error"
            >{{ v$.form.kode.required.$message }}</small
          >
        </div>
        <div class="field col-12 md:col-8">
          <label :class="{ 'p-error': v$.form.nama.$invalid && submitted }"
            >Nama *</label
          >
          <InputText
            v-model="form.nama"
            :class="{ 'p-invalid': v$.form.nama.$invalid && submitted }"
            type="text"
            class="w-full"
          />
          <small
            v-if="
              (v$.form.nama.$invalid && submitted) ||
              v$.form.nama.$pending.$response
            "
            class="p-error"
            >{{ v$.form.nama.required.$message }}</small
          >
        </div>
      </div>
      <div class="flex justify-content-end align-items-end">
        <Button
          :loading="loading"
          label="Simpan"
          icon="pi pi-check"
          type="submit"
        />
      </div>
    </form>
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { helpers, required } from '@vuelidate/validators'

export default {
  setup: () => ({ v$: useVuelidate() }),
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      submitted: false,
    }
  },
  computed: {
    form() {
      return this.item
    },
  },
  methods: {
    handleSubmit(isFormValid) {
      this.submitted = true

      if (!isFormValid) {
        return
      }

      this.$emit('save', this.form)
    },
  },
  validations() {
    return {
      form: {
        kode: {
          required: helpers.withMessage('Kode harus diisi.', required),
        },
        nama: {
          required: helpers.withMessage('Nama area harus diisi.', required),
        },
      },
    }
  },
}
</script>
